import React from 'react';
import { Close } from '@withjoy/joykit/icons';
import { MobileBlogMenu } from '../MobileBlogMenu';
import { MobileMainMenu } from '../MobileMainMenu';
import { Box, Flex, DrawerV2 } from '@withjoy/joykit';
import { MobileSubMainMenu } from '../MobileSubMainMenu';
import { useEventCallback } from '@shared/utils/hooks/useEventCallback';
import { StyledIconBrandLogoNoColor, styles } from './MobileMenuDrawer.styles';
import { MobileMenuType, useMobileViewContext } from '../../MobileView.provider';
import { StorefrontNavigator } from '@apps/registry/common/components/Catalog/components/StorefrontNavigator';
import { useShopStorefrontContext } from '@apps/registry/common/components/Catalog/components/ShopStorefrontProvider';

export const MobileMenuDrawer: React.FC = () => {
  const { isMobileNavOpen, selectedMenu, setMobileNavIsOpen, onClickBack } = useMobileViewContext();
  const { config } = useShopStorefrontContext();
  const handleOnClose = useEventCallback(() => {
    onClickBack(true);
    setMobileNavIsOpen(false);
  });
  return (
    <DrawerV2
      anchor="left"
      isOpen={isMobileNavOpen}
      overrides={{ Content: { props: { width: '100%' } } }}
    >
      <Box __css={styles.storefrontNavigatorPlacement}>
        <StorefrontNavigator
          colorVariant="light"
          spacing="compact"
        />
      </Box>
      <Flex
        justifyContent="space-between"
        padding={6}
        paddingBottom={5}
      >
        <Box
          as="a"
          href={config.homePageUrl}
        >
          <StyledIconBrandLogoNoColor style={{ ...styles.iconBrandLogoNoColor }} />
        </Box>
        <Flex
          as="button"
          alignItems="center"
          onClick={handleOnClose}
        >
          <Close
            title="Close"
            size={32}
          />
        </Flex>
      </Flex>
      {selectedMenu === MobileMenuType.mainMenu && <MobileMainMenu />}
      {selectedMenu === MobileMenuType.subMenu && <MobileSubMainMenu />}
      {selectedMenu === MobileMenuType.blogMenu && <MobileBlogMenu />}
    </DrawerV2>
  );
};
